module.exports = __webpack_public_path__ + "static/media/account-image2.f1005cf7.png";